import format from 'date-fns/format';
import add from 'date-fns/add';
import { endOfDay, formatDuration } from 'date-fns/esm';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';
import { pl, enUS, sk, it, fr, es, nl, cs, de, ru, uk } from 'date-fns/locale';
import { ACTIVATION_CODE_LENGTH, BillingCycleUnit, partsOfPlanTypes, } from './constants';
const mapCodeToImport = {
    pl: pl,
    en: enUS,
    sk: sk,
    it: it,
    fr: fr,
    es: es,
    nl: nl,
    cs: cs,
    de: de,
    ru: ru,
    uk: uk,
};
export const displayDate = (date) => format(new Date(date), 'dd/MM/yyyy');
export const getExpirationDateAfterMonths = (months) => {
    const date = add(new Date(), { months: months });
    return format(date, 'dd/MM/yyyy');
};
export const getExpirationDateAfterDays = (days) => {
    const date = add(new Date(), { days: days });
    return format(date, 'dd/MM/yyyy');
};
export const formatDateToBeSeparatedByDots = (date) => format(new Date(date), 'dd.MM.yyyy');
export const getDurationText = (time, lang) => {
    const language = mapCodeToImport[lang];
    const durationFormat = time.unit === BillingCycleUnit.DAY ? 'days' : 'months';
    return formatDuration({ [durationFormat]: time.count }, { locale: language });
};
export const calculateDistance = (date, lang) => {
    const language = mapCodeToImport[lang];
    return formatDistanceToNowStrict(endOfDay(new Date(date)), {
        locale: language,
        roundingMethod: 'floor',
    });
};
export const getPlanNameWithCapitalizedPlanType = (planName) => {
    const regex = new RegExp(partsOfPlanTypes.join('|'), 'gi');
    return planName.replace(regex, (planType) => planType.toUpperCase());
};
export const formatPlanName = (planName) => {
    const planNameLowerCase = planName.toLowerCase();
    return getPlanNameWithCapitalizedPlanType(planNameLowerCase);
};
export const getUnselectedUsers = (selectedUsers, activeUsers) => {
    const unselectedUsers = activeUsers.filter(({ id: activeUserId }) => !selectedUsers.some(({ id: selectedUserId }) => activeUserId === selectedUserId));
    return unselectedUsers;
};
export const sortAccountList = (accounts, sortingParam, currentUserParam) => {
    return accounts.sort((a, b) => {
        if (a[sortingParam] === currentUserParam)
            return -1;
        if (b[sortingParam] === currentUserParam)
            return 1;
        return 0;
    });
};
export const parseActivationCode = (code) => code.replace(/_/g, '');
export const isEntireCodeGiven = (code) => code.length === ACTIVATION_CODE_LENGTH;
